import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';

const ParticipanteQuizCard = ({ participantequiz }) => {

    const history = useHistory();

    return (
        <div className={styles.wrapper}>
            <div className={styles.bodyCard}>
                <div className={styles.title}>
                    Nome
                </div>
                <div className={styles.info}>
                    {participantequiz.nomeParticipante}
                </div>
                <div className={styles.title}>
                    Distribuidor
                </div>
                <div className={styles.info}>
                    {participantequiz.distribuidor}
                </div>
            </div>

            <div className={styles.actionWrapper}>

                <div>
                    <small>Perguntas<br/>totais</small> <br/>
                    <div className={styles.black}>{participantequiz.perguntasTotais}</div>
                </div>
                
                <div>
                    <small>Acertos <br/> totais</small> <br/>
                    <div className={styles.green}>{participantequiz.acertosTotais}</div>
                </div>

                <div>
                    <small>Pontos <br/> ganhos</small> <br/>
                    <div className={styles.orange}>{participantequiz.pontosGanhos}</div>
                </div>
            </div>

        </div>
    )
}

export default ParticipanteQuizCard;